import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-16 bg-background-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20background%20with%20warm%20crimson%20and%20gold%20accents%2C%20geometric%20newspaper%20collage%20texture%2C%20investigative%20journalism%20theme%2C%20subtle%20circuit%20patterns%2C%20dramatic%20lighting%2C%20no%20blue%20or%20purple%20tones%2C%20editorial%20photography%20style&width=1920&height=600&seq=cta-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>

      <div className="container-main relative z-10">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50">
            你有料，我有平台
          </h2>
          <p className="mt-3 text-sm text-background-300 leading-relaxed">
            无论你是内部知情者、行业从业者还是亲历者，黑料社区给你一个安全、匿名的发声渠道。
            你的爆料，可能改变整个行业。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
            <Link
              to="/about"
              className="w-full sm:w-auto px-8 py-3.5 text-sm font-medium rounded-full bg-primary-500 text-white hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
            >
              立即爆料
              <i className="ri-send-plane-line ml-2"></i>
            </Link>
            <Link
              to="/category/entertainment"
              className="w-full sm:w-auto px-8 py-3.5 text-sm font-medium rounded-full bg-background-50/10 border border-background-50/20 text-background-50 hover:bg-background-50/20 transition-all duration-300 whitespace-nowrap"
            >
              浏览更多
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-2 mt-8">
            {['严格匿名保护', '实名审核机制', '法律合规保障', '7×24小时响应'].map((feature) => (
              <span
                key={feature}
                className="px-3 py-1.5 text-xs rounded-full bg-background-800/60 text-background-300 border border-background-700/40"
              >
                <i className="ri-shield-check-line mr-1 text-accent-400"></i>
                {feature}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}